module.exports = __webpack_public_path__ + "img/georgina-moreno-byn.ea2f6682.png";